import * as R from 'ramda';
import pathIsTruthy from './pathisTruthy';

const pathIsFalsy = R.complement(pathIsTruthy);

export default pathIsFalsy;
